export const primaryColor= "#0C95CC";
export const secondaryColor = "#BCD22F";
export const textLightColor = "#fff";
export const textDarkColor = "#000";
export const textGreyColor = "#464342";